module.exports = __webpack_public_path__ + "static/chilli-beans-2-8d6aa489da948d37c2bd89955832720e.jpg";